import React from 'react';
import { Card, Descriptions, Tag, Space, Grid, Typography } from 'antd';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const BranchCard = ({ branch, actions }) => {
  const screens = useBreakpoint();

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'green';
      case 'inactive': return 'orange';
      case 'under_maintenance': return 'blue';
      case 'closed': return 'red';
      default: return 'default';
    }
  };

  const formatAddress = (address) => {
    if (!address) return '-';
    const parts = [address.street, address.city, address.state, address.country].filter(Boolean);
    return parts.join(', ') || '-';
  };

  return (
    <Card
      size="small"
      style={{ marginBottom: 16 }}
      actions={actions}
      hoverable
    >
      <Card.Meta
        title={
          <Space>
            <Text strong style={{ fontSize: screens.xs ? '14px' : '16px' }}>
              {branch.name}
            </Text>
            <Tag color={getStatusColor(branch.status)} size="small" style={{ textTransform: 'capitalize' }}>
              {branch.status}
            </Tag>
          </Space>
        }
        description={
          <div style={{ fontSize: screens.xs ? '12px' : '14px' }}>
            <div style={{ marginBottom: 4 }}>
              <Text strong>Code:</Text> <Text code>{branch.code}</Text>
            </div>
            
            {branch.address && (
              <div style={{ marginBottom: 4 }}>
                <Text strong>Address:</Text> {formatAddress(branch.address)}
              </div>
            )}
            
            {branch.manager?.name && (
              <div style={{ marginBottom: 4 }}>
                <Text strong>Manager:</Text> {branch.manager.name}
              </div>
            )}
            
            {branch.contactDetails?.phone && (
              <div style={{ marginBottom: 4 }}>
                <Text strong>Phone:</Text> {branch.contactDetails.phone}
              </div>
            )}
            
            {branch.operationalHours?.openTime && branch.operationalHours?.closeTime && (
              <div style={{ marginBottom: 4 }}>
                <Text strong>Hours:</Text> {branch.operationalHours.openTime} - {branch.operationalHours.closeTime}
              </div>
            )}
          </div>
        }
      />
    </Card>
  );
};

export default BranchCard;
